import Image from "next/image"

interface ButtonProps {
  handler?: () => void
  label?: string
  customClass?: string
  icon?: React.ReactNode
  image?: string
  disabled?: boolean
  dataCy?: string
}

const FormButton: React.FC<ButtonProps> = ({ handler, label, customClass, icon, image, disabled, dataCy }) => {
  return (
    <button
      onClick={handler}
      className={`flex h-auto flex-shrink-0 flex-grow-0 items-center justify-center rounded px-4 text-[14px] font-[600] text-white  ${
        disabled ? "cursor-not-allowed bg-[#44373733]" : "bg-black"
      } ${customClass}`}
      disabled={disabled}
      data-cy={dataCy}
    >
      {icon && <div className="mr-2">{icon}</div>}

      {image && (
        <div className="relative mr-2 h-4 w-4">
          <Image src={image} alt="button-icon" layout="fill" objectFit="contain" />
        </div>
      )}

      <span className={`py-1 ${disabled ? "text-[#443737] text-opacity-20" : "text-white"}`}>{label}</span>
    </button>
  )
}

export default FormButton
